import { gql } from "@apollo/client";

export const SCRAPE = gql`
  mutation scrape($id: Int!, $action: String!) {
    scrape(id: $id, action: $action) {
      id
      message
      isError
    }
  }
`;
